<template>
  <div>
    <div :style="style" ref="lavContainer" v-show="!error && !loading"></div>
    <!-- Slot para definir o que será exibido enquanto a animação é carregada. Pode ser que o lottie não tenha sido carregado, aumentando o tempor de requisição -->
    <slot name="loading" v-if="loading">
      <span v-if="!hideThumbnail">Loading...</span>
    </slot>
    <!-- Slot para definir o que será exibido quando houver um erro no carregamento da animação -->
    <slot name="error" v-if="error">
      <span>:(</span>
    </slot>
  </div>
</template>

<script>

export default {
  props: {
    // Animation name or object (Lottie file)
    animation: {
      type: [Object],
      required: true,
    },
    // Largura da animação
    width: { type: [Number, String], default: '100%', },
    // Altura da animação
    height: { type: [Number, String], default: '100%', },
    // Opções aceitas pelo Lottie para animação
    rendererSettings: { type: Object, },
    // Roda apenas umas vez a animação
    singlePlay: { type: Boolean, },
    // Carrega animação mas não toca imadiatamente
    noAutoplay: { type: Boolean, },
    hideThumbnail: { type: Boolean, },
  },
  data () {
    return {
      error: false,
      loading: true,
      lottieAnimation: undefined,
    };
  },
  computed: {
    style () {
      return `
        width: ${this.width};
        height: ${this.height};
        overflow: 'hidden';
        margin: '0 auto';
      `;
    },
  },
  methods: {
    async loadLottie () {
      try {
        const lottie = await import('lottie-web');
        this.lottieAnimation = lottie.loadAnimation({
          container: this.$refs.lavContainer,
          renderer: 'svg',
          loop: !this.singlePlay,
          autoplay: !this.noAutoplay,
          animationData: this.animation,
          rendererSettings: this.rendererSettings,
        });
        this.$emit('animCreated', this.lottieAnimation);
        if (!this.noAutoplay)
          this.play();
      } catch (ex) {
        this.error = true;
        this.$store.commit('setError', ex);
      }
      this.loading = false;
    },
    play () {
      this.lottieAnimation.play();
    },
  },
  async mounted () {
    await this.loadLottie();
  },
};
</script>
